import type { FC } from 'react';

import { useTranslation } from 'react-i18next';

import Content from './Content';
import Header from './Header';

import { StyledBodyText } from './Typography';

const Loading: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<Header />
			<Content>
				<StyledBodyText>{t('loading.text.loading')}</StyledBodyText>
			</Content>
		</>
	);
};

export default Loading;
